import { isNullOrEmptyArray } from "src/util/arrays";
import { getIdListHasDuplicates } from "./util";

/**
 * Lida com a ação de combinar alternativas / enviar alternativa para um grupo de combinação no passo 2
 * e no passo 3. Dada regra de negócio definida com o time de produto em 04/01/22, como não podemos combinar 
 * alternativas que possuam o mesmo id de pesquisa, ou enviá-las para um grupo de alternativas pré-existente, 
 * essa função foi criada para tornar esse processo dinâmico.
 *
 * Ações que executam essa função:
 * - Combinar alternativas.
 * - Enviar uma alternativa para um grupo de alternativas.
 * @param {array<number>} comparedIdList Array de referência
 * @param {array<number>} comparativeIdList Array comparado
 * @param {Function} successCallback
 * @param {Function} errorCallback
 */
export function handleOnExecuteCombinationActions(
  comparedIdList = [],
  comparativeIdList = [],
  successCallback = null,
  errorCallback = null,
) {
  if (isNullOrEmptyArray(comparedIdList)) {
    return null;
  }

  // Recupera um booleano que indica se a lista de id's contém alguma duplicação.
  let hasDuplication = null;

  if (isNullOrEmptyArray(comparativeIdList)) {
    hasDuplication = getIdListHasDuplicates(comparedIdList);
  } else {
    hasDuplication = comparativeIdList.some((id) => comparedIdList.includes(id));
  }

  // RN: Caso o usuário tente combinar uma ou mais alternativas que possuam id de pesquisa igual
  // essa operação deve ser bloqueada exibindo uma flash message de alerta.
  if (hasDuplication) {
    // Executa uma callback de erro
    if (typeof errorCallback === 'function') {
      errorCallback();
    }
    // Bloqueia o fluxo de execução
    return;
  }

  // Executa uma callback de sucesso.
  if (typeof successCallback === "function") {
    successCallback();
  }
};
